import { ReactNode } from 'react';
import { Heading } from '../../../../../v2/js/components/heading';

export type HomeSectionProps = {
  headingText: string;
  components: ReactNode[];
  actionText: string;
  actionFunction?: () => void;
};

export function HomeSection(props: HomeSectionProps) {
  const { headingText, components, actionText, actionFunction } = props;

  return (
    <section className="tw:mt-6">
      <div className="tw:flex tw:items-center tw:justify-between tw:mb-3">
        <span className="tw:text-xl tw:font-semibold">{headingText}</span>
        {actionText && actionFunction ? (
          // TODO: make this a Button state
          <button
            className="tw:text-brand-green-1 tw:hover:text-brand-green-1/90 tw:text-sm tw:font-medium tw:bg-transparent tw:border-none tw:cursor-pointer"
            onClick={actionFunction}
          >
            {actionText}
          </button>
        ) : null}
      </div>
      <div>
        {components.map((node, index) => (
          <div key={index} className={index > 0 ? 'tw:mt-3' : undefined}>
            {node}
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeSection;
